"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.profileShape = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _researchTag = require("./researchTag.shape");

var profileShape = _propTypes.default.shape({
  id: _propTypes.default.number,
  avatar: _propTypes.default.string.isRequired,
  email: _propTypes.default.string.isRequired,
  firstName: _propTypes.default.string.isRequired,
  fullName: _propTypes.default.string.isRequired,
  lastName: _propTypes.default.string.isRequired,
  employment: _propTypes.default.string,
  company: _propTypes.default.string,
  education: _propTypes.default.string,
  location: _propTypes.default.string,
  phoneNumber: _propTypes.default.string,
  countryId: _propTypes.default.number,
  researchTags: _propTypes.default.arrayOf(_researchTag.researchTagShape).isRequired
});

exports.profileShape = profileShape;